import { useCallback, useState } from "react";
import ReportService from "../../../../../../../services/reportGeneration";
import { useSaveDownloaded } from "../../../../../../../lib/hooks/useSaveDownloaded";

export const useDownloadText = (name: string) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { save } = useSaveDownloaded(name, "text/plain", setIsLoading);

  const download = useCallback(
    async (id?: string) => {
      try {
        if (id) {
          const res: any = await ReportService.download(id);

          save(res);
        }
      } catch {
        setIsLoading(false);
      }
    },
    [save]
  );

  return { isLoading, setIsLoading, download };
};
